module.exports = __webpack_public_path__ + "img/anforalog.c06ae373.jpg";